import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "edu-wrap" }
const _hoisted_3 = { class: "edu-main" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "edu-details" }
const _hoisted_8 = { class: "spec-and-degree" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "extra-wrap" }
const _hoisted_13 = {
  key: 0,
  class: "extra-item"
}
const _hoisted_14 = { class: "simple-list" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "journal" }
const _hoisted_17 = {
  key: 1,
  class: "extra-item"
}
const _hoisted_18 = { class: "simple-list" }
const _hoisted_19 = {
  key: 0,
  class: "subname"
}
const _hoisted_20 = {
  key: 2,
  class: "extra-item"
}
const _hoisted_21 = { class: "simple-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Degree = _resolveComponent("Degree")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.education')), 1),
    _createElementVNode("section", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.education, (edu) => {
        return (_openBlock(), _createElementBlock("article", {
          key: edu.Name,
          class: "edu-item"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", {
              class: "edu-name",
              innerHTML: edu.Name
            }, null, 8, _hoisted_4),
            _createElementVNode("span", {
              class: "edu-place",
              innerHTML: edu.Place
            }, null, 8, _hoisted_5)
          ]),
          (edu.Field)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "edu-field",
                innerHTML: edu.Field
              }, null, 8, _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(edu.Details, (d) => {
              return (_openBlock(), _createElementBlock("div", {
                key: d.Spec + d.Year,
                class: "edu-detail"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", {
                    class: "spec",
                    innerHTML: d.Spec
                  }, null, 8, _hoisted_9),
                  (d.Thesis)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "spec gray",
                        innerHTML: d.Thesis
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true),
                  (d.Degree)
                    ? (_openBlock(), _createBlock(_component_Degree, {
                        key: 1,
                        degree: d.Degree,
                        desc: d.Desc
                      }, null, 8, ["degree", "desc"]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", {
                  class: "year",
                  innerHTML: d.Year
                }, null, 8, _hoisted_11)
              ]))
            }), 128))
          ])
        ]))
      }), 128)),
      _createElementVNode("section", _hoisted_12, [
        (_ctx.publications.length)
          ? (_openBlock(), _createElementBlock("article", _hoisted_13, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.publications')), 1),
              _createElementVNode("ul", _hoisted_14, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publications, (pub) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: pub.Name
                  }, [
                    _createElementVNode("span", {
                      innerHTML: pub.Authors
                    }, null, 8, _hoisted_15),
                    _cache[0] || (_cache[0] = _createTextVNode(", ")),
                    _createElementVNode("em", null, "\"" + _toDisplayString(pub.Name) + "\"", 1),
                    _cache[1] || (_cache[1] = _createTextVNode(", ")),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(pub.Journal), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.conferences.length)
          ? (_openBlock(), _createElementBlock("article", _hoisted_17, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.conferences')), 1),
              _createElementVNode("ul", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conferences, (conf) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: conf.Name
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(conf.Name), 1),
                    (conf.Subname)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, " - " + _toDisplayString(conf.Subname), 1))
                      : _createCommentVNode("", true),
                    _cache[2] || (_cache[2] = _createTextVNode(" — ")),
                    _createElementVNode("span", null, _toDisplayString(conf.Place) + " - " + _toDisplayString(conf.Year), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.courses.length)
          ? (_openBlock(), _createElementBlock("article", _hoisted_20, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.$t('cv.courses')), 1),
              _createElementVNode("ul", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: course.Name
                  }, [
                    _createElementVNode("strong", null, _toDisplayString(course.Name), 1),
                    _cache[3] || (_cache[3] = _createTextVNode(" — ")),
                    _createElementVNode("span", null, _toDisplayString(course.Place), 1)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}